import { render, staticRenderFns } from "./EditCompanyUserRoleDialog.vue?vue&type=template&id=5c499ad2"
import script from "./EditCompanyUserRoleDialog.vue?vue&type=script&lang=ts"
export * from "./EditCompanyUserRoleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports